import { createAsyncThunk } from "@reduxjs/toolkit";

import productsService from "../../../api/services/products";
import { applyCartAvailability } from "./slice";

/*
 * Korpa se čuva u localStorage-u, pa stavka preživi gašenje proizvoda —
 * kupac je mogao da vidi i poruči proizvod koji više nije u prodaji.
 * Ovo pita backend koji su id-jevi iz korpe još dostupni i izbacuje ostale.
 *
 * Namerno jedan poziv za sve stavke: ako padne mreža, thunk pukne i korpa
 * ostane netaknuta, umesto da se delimično isprazni zbog lošeg interneta.
 * Vraća imena uklonjenih proizvoda da UI može da javi korisniku šta se desilo.
 */
export const validateCartAvailability = createAsyncThunk(
  "cart/validateAvailability",
  async (_, { getState, dispatch }) => {
    const items = getState().cart?.items || [];
    const ids = [...new Set(items.map((item) => item.id).filter(Boolean))];

    if (ids.length === 0) {
      return { removedNames: [] };
    }

    const response = await productsService.getProductsAvailability(ids);
    const availability = Array.isArray(response?.data) ? response.data : [];

    const unavailableIds = new Set(
      availability.filter((entry) => !entry.available).map((entry) => entry.id),
    );
    const removedNames = [
      ...new Set(
        items
          .filter((item) => unavailableIds.has(item.id))
          .map((item) => item.name),
      ),
    ];

    dispatch(applyCartAvailability(availability));

    return { removedNames };
  },
);
